import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class LoanSetting extends Component {
  render() {
    return (
      <EntityList apiRoute='api/loansetting' title='Remorque - Paramètres de prêt' editTitle='Paramètres de prêt' displayColumns={[
        {Description: 'Taux', Column: 'Rate'},
        {Description: 'Nombre d\'année(s)', Column: 'NumberOfYear'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default LoanSetting;


/** WEBPACK FOOTER **
 ** ./src/app/routes/general/LoanSetting.js
 **/